const t = "Paso completado", o = "Volver a {buttonName}", e = "Continuar a {buttonName}", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
